// Central config for the Screaming Chicken / HRS landing page
export const TOKEN = {
  name: "SCREAMING CHICKEN",
  ticker: "$AHHH",
  org: "Homelessness Reform Society",
  contract: "3Atv2msRFLpgPTKHxALnKWTNXrbgCvg4TWZdCHYZpump",
  treasury: "9oCc1vpHFwxXb9sLJPeDQbZMzeMFJGiuS7nUSmsgrKsh",
  chain: "SOLANA",
  countdownISO: "2027-01-29T00:00:00Z",
};

export const LINKS = {
  pumpfun: `https://pump.fun/coin/${TOKEN.contract}`,
  dexscreener: `https://dexscreener.com/solana/${TOKEN.contract}`,
};

export const SOCIALS = [
  { key: "x", label: "X · @NAKIboiDEV", handle: "@NAKIboiDEV", url: "https://x.com/NAKIboiDEV" },
  { key: "discord", label: "Discord", handle: "The Flock", url: "https://discord.gg/3SBUtaXuS" },
  { key: "tiktok", label: "TikTok · @cryptonaut99", handle: "@cryptonaut99", url: "https://www.tiktok.com/@cryptonaut99" },
];

export const IMAGES = {
  mascot:
    "https://customer-assets-0z36b82j.emergentagent.net/job_a507d45e-b9e8-4918-a6c8-1a30732cd3a3/artifacts/18xjggya_screaming%20chicken.jpg",
  comic:
    "https://customer-assets-0z36b82j.emergentagent.net/job_a507d45e-b9e8-4918-a6c8-1a30732cd3a3/artifacts/e7ajxeui_screaming%20chicken3.jpg",
  mission:
    "https://customer-assets-0z36b82j.emergentagent.net/job_a507d45e-b9e8-4918-a6c8-1a30732cd3a3/artifacts/05r8jl0h_screaming%20chicken2.jpg",
};
